module.exports = __webpack_public_path__ + "static/media/test-tube-negative.8dbe6473.svg";